import { render, staticRenderFns } from "./editVisitPro.vue?vue&type=template&id=488da1b1&scoped=true"
import script from "./editVisitPro.vue?vue&type=script&lang=js"
export * from "./editVisitPro.vue?vue&type=script&lang=js"
import style0 from "./editVisitPro.vue?vue&type=style&index=0&id=488da1b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488da1b1",
  null
  
)

export default component.exports